import React, { useState, useEffect } from "react";
import { Button, message } from "antd";
import OtpInput from "react-otp-input";
import { sendSignupOTP } from "../actions";

import "../Login.scss";

let timeInterval = null;
let countDownTemp = 120;

const RegisterStep1 = ({
  handleChangeStep = () => {},
  dataForm = {},
  handleChangeDataForm = () => {},
}) => {
  const [countDown, setCountDown] = useState(120);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    genCountDown();
    countDownTemp = 120;
    return () => {
      clearInterval(timeInterval);
    };
  }, []);

  const genCountDown = () => {
    timeInterval = setInterval(() => {
      if (countDownTemp === 0) {
        countDownTemp = 120;
        clearInterval(timeInterval);
      } else {
        countDownTemp = countDownTemp - 1;
        setCountDown(countDownTemp);
      }
    }, 1000);
  };

  const handleChange = (otp) => {
    setOtp(otp);
  };

  const handleSubmitOtp = () => {
    if (otp.length === 6) {
      handleChangeDataForm({
        ...dataForm,
        otp: otp,
      });
      handleChangeStep(3);
    } else {
      message.error("Vui lòng nhập đầy đủ mã OTP");
    }
  };

  const reSendOtp = async () => {
    try {
      const dataDto = {
        phone: dataForm.phone,
      };
      const { data } = await sendSignupOTP(dataDto);
      if (data.code === 200) {
        countDownTemp = 120;
        genCountDown();
        data?.message && message.success(data?.message);
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {}
  };

  return (
    <div className="register-step-2">
      <div className="title-step2">
        <span className="title-phone">
          Mã xác nhận đã được gửi tới số điện thoại
        </span>
        <span className="value-phone">{dataForm.phone}</span>
      </div>
      <div className="box-otp">
        <OtpInput
          onChange={handleChange}
          numInputs={6}
          value={otp}
          shouldAutoFocus
          isInputNum
          inputStyle={{
            textAlign: "center",
            borderRadius: "50%",
            position: "relative",
            border: `1px solid #00B6F3`,
            backgroundColor: "#fff",
            fontSize: 24,
            width: 50,
            height: 50,
            padding: 0,
            margin: "0 4px",
            lineHeight: 29,
            fontWeight: 600,
            color: "#00B6F3",
            "&:focus": {
              outline: "none",
            },
          }}
          containerStyle={{
            width: "100%",
          }}
        />
      </div>
      <Button type="text" className="btn-continus" onClick={handleSubmitOtp}>
        Tiếp tục
      </Button>
      <div className="resend-otp-box">
        <Button
          type="text"
          className="btn-resend-otp"
          onClick={() => {
            if (countDown === 0) {
              reSendOtp();
            }
          }}
        >
          Gửi lại mã.
        </Button>
        {countDown !== 0 && (
          <div style={{ color: "#00B6F3" }}>{`${countDown}s`}</div>
        )}
      </div>
    </div>
  );
};

export default RegisterStep1;
